import { TagTestStepReportComponent } from './tag-test-step-report/tag-test-step-report.component';
import { TagTestcaseReportComponent } from './tag-testcase-report/tag-testcase-report.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ProjectSummaryReportComponent } from './project-summary-report/project-summary-report.component';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { ReportRoutingModule } from './report-routing.module';
import { ActiveReportComponent } from './active-report/active-report.component';
import { HistoricalReportComponent } from './historical-report/historical-report.component';
import { LatestReportComponent } from './latest-report/latest-report.component';
import { ManageConsoleExecutionComponent } from './manage-console-execution/manage-console-execution.component';
import { SuiteReportComponent } from './suite-report/suite-report.component';
import { TagReportComponent } from './tag-report/tag-report.component';
import { TestResultSummaryComponent } from './test-result-summary/test-result-summary.component';
import { TestRunDetailComponent } from './test-run-detail/test-run-detail.component';
import { ReportComponent } from './report.component';
import { SharedModule } from '../shared/shared.module';
import { AngularMaterialModule } from '../angular-material.module';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { LayoutModule } from '../layout/layout.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';


@NgModule({
  declarations: [
    ReportComponent,LatestReportComponent, HistoricalReportComponent, TagReportComponent, 
    ActiveReportComponent, TestResultSummaryComponent, TestRunDetailComponent, SuiteReportComponent, 
    ManageConsoleExecutionComponent,ProjectSummaryReportComponent,TagTestcaseReportComponent,TagTestStepReportComponent
    
  ],
  imports: [
    CommonModule,
    ReportRoutingModule,
    SharedModule,
    AngularMaterialModule,
    ChartsModule,
    LayoutModule,
    NgxPaginationModule,
    NgMultiSelectDropDownModule
  ],
  providers: [
    ThemeService,
    DatePipe
  ],
})
export class ReportModule { }
